export default class ExpandTransaction {
  constructor(context) {
    this.context = context;
  }

  run({ isExpanded }) {
    this.context.analytics.track('Customer Profile - Expand Transaction', { isExpanded });
  }
}
